export default "__VITE_ASSET__a8234900__"